import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component,  Inject, OnDestroy, OnInit, PLATFORM_ID, input } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'clever-category',
    templateUrl: './category.component.html',
    styleUrls: ['./category.component.scss'],
    standalone: false
})
export class CategoryComponent implements OnInit, OnDestroy {
    readonly mode = input<string>(undefined);
    isBrowser: boolean = false;
    selectedCat: number = 0;
    protected unsubscribe$ = new Subject();
    tmparr: number[] = [1, 2, 3, 4, 5, 6];

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    select(k) {
        this.selectedCat = k;
        this.hotelService.category(this.selectedCat, this.mode() !== 'home');
        this.cdr.detectChanges();
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.selectedCat = filter.minCategory;
            this.cdr.detectChanges();
        });
    }
}
